import { createBrowserRouter } from "react-router-dom";
import { pca } from "./msalConfig";
import CoreScheduleImporter from "./pages/core-schedule-importer";
import EMREntry from "./pages/home";
import { Login } from "./pages/login";
import UserManagement from "./pages/manage-users";
import Home from "./pages/menu";
import MrrDocuments from "./pages/mrr-documents";
import WciOrthoSurgeryVisit from "./pages/wci-ortho-surgery-visit";
import { PermissionsProvider } from "./permission-context";
import ProtectedRoute from "./ProtectedRoute";
import PhoneDictationStatus from "./pages/phone-dictation-status";
import DeviceInfo from "./pages/device-info";
import AppNotificationLogs from "./pages/app-notification-logs";

// Function to get the access token from cookies
const getAccessToken = async () => {
  const account = await pca.getActiveAccount();
  if (!account) {
    return false;
  } else {
    return true;
  }
};

// Function to check if the user is authenticated
const isAuthenticated = async () => {
  return !!(await getAccessToken());
};

// Create the router configuration
const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
    index: true,
  },
  {
    element: (
      <PermissionsProvider>
        <ProtectedRoute isAuthenticated={isAuthenticated} />
      </PermissionsProvider>
    ),
    children: [
      {
        path: "/emrentry",
        element: <EMREntry />,
      },
      {
        path: "/manage-users",
        element: <UserManagement />,
      },
      {
        path: "/wci-ortho-surgery-visit",
        element: <WciOrthoSurgeryVisit />,
      },
      {
        path: "/core-schedule-importer",
        element: <CoreScheduleImporter />,
      },
      {
        path: "/home",
        element: <Home />,
      },
      {
        path: "/mrr-documents",
        element: <MrrDocuments />,
      },
      {
        path: "/phone-dictation-status",
        element: <PhoneDictationStatus />,
      },
      {
        path: "/device-info",
        element: <DeviceInfo />,
      },
      {
        path: "/app-notification-logs",
        element: <AppNotificationLogs />,
      },
    ],
  },
  {
    path: "*",
    element: <p>404 Error - Nothing here...</p>,
  },
]);

export default router;
